var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{class:{
      'gala-btn text-uppercase full-width line-height-em': true,
      'medium-font': _vm.$vuetify.breakpoint.xl,
    },staticStyle:{"display":"flex","align-items":"center","justify-content":"center","gap":"5px"},on:{"click":function($event){_vm.goTo(_vm.getPlatformDownloadLink())}}},[_c('img',{attrs:{"src":_vm.buttonText().icon,"aria-hidden":"true"}}),_vm._v("\n    "+_vm._s(_vm.buttonText().text)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }